import Vue from 'vue';
import Vuex from 'vuex';
import _ from 'lodash';
import { filters } from 'src/utils/consts';
import { getData } from 'src/utils/api';


Vue.use(Vuex);

export default () => new Vuex.Store({
  state() {
    return {
      portfolio: {},
      portfolio_item: {},
      browser: '',
      device: '',
      filter: 'all',
      category: '',
      subcategory: '',
      notEmptyTypes: [],
    };
  },
  getters: {
    portfolio(state) {
      let result = state.portfolio;
      let obj = [];
      if (state.category) {
        result = result.filter((item) => {
          if (state.subcategory) {
            return _.startsWith(item.type, state.subcategory);
          }
          return _.startsWith(item.type, state.category);
        });
      }
      if (state.category === '' && state.subcategory === '') {
        obj = _.sortBy(result, ['position_all']);
      } else {
        obj = _.sortBy(result, ['position_filter']);
      }
      return obj;
    },
    portfolio_item(state) {
      return state.portfolio_item;
    },
    browser(state) {
      return state.browser;
    },
    device(state) {
      return state.device;
    },
    subcategory_list(state) {
      const category = filters.find(el => el.tp === state.category);
      const filter = category.types.filter(el => state.notEmptyTypes.indexOf(el.tp) !== -1 || el.tp === '');
      return filter;
    },
    description(state) {
      const category = filters.find(el => el.tp === state.category).types;
      const item = category.find(el => el.tp === state.subcategory);
      if (item === undefined) {
        return '';
      }
      return item.desc;
    },
  },
  mutations: {
    ADD_PORTFOLIO(state, data) {
      state.portfolio = data;
    },
    ADD_PORTFOLIO_ITEM(state, data) {
      state.portfolio_item = data;
    },
    CHANGE_BROWSER(state, name) {
      state.browser = name;
    },
    SET_DEVICE(state, device) {
      state.device = device;
    },
    SET_FILTER(state, filter) {
      state.filter = filter;
    },
    SET_CATEGORY(state, category) {
      state.category = category;
    },
    SET_SUBCATEGORY(state, subcategory) {
      state.subcategory = subcategory;
    },
    SET_NOT_EMPTY_CATEGORY(state, types) {
      state.notEmptyTypes = types;
    },
    CLEAR_STORE_FILTER(state) {
      state.category = '';
      state.subcategory = '';
    },
  },
  actions: {
    async fetchPortfolio({ commit }) {
      const data = await getData('/pages/');
      commit('ADD_PORTFOLIO', data);
    },

    async fetchItem({ commit }, id) {
      const data = await getData(`/pages/${id}`);
      commit('ADD_PORTFOLIO_ITEM', data);
    },
    setFilter({ commit }, filter) {
      commit('SET_FILTER', filter);
    },
    setCategory({ commit }, category) {
      commit('SET_CATEGORY', category);
      commit('SET_SUBCATEGORY', '');
    },
    setSubCategory({ commit }, subcategory) {
      commit('SET_SUBCATEGORY', subcategory);
    },
    async fetchNotEmptyCategory({ commit }) {
      const data = await getData('/pages/items-filters/');
      commit('SET_NOT_EMPTY_CATEGORY', data.types);
    },
    clearStoreFilter({ commit }) {
      commit('CLEAR_STORE_FILTER');
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/store.js